/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React from "react";

import { usePlayerTranslation } from "../../../../../../shared/context/PlayerTranslationContext";
import NextIcon from "../../../../../../shared/icons/player/Next.svg";
import { usePlayerSettings } from "../../../../../BasePlayer";
import { usePlayerCurrentMedia } from "../../../../../Controller";
import { useOverlayState } from "../../../../../Overlay";
import { ToggleButton } from "../../../../Base";

import { NextEpisodeDialog } from "./NextEpisodeDialog";

export const NextEpisodeButton = () => {
  const { toggleSettings } = useOverlayState();
  const { nextMedia } = usePlayerCurrentMedia();

  const {
    ui: { tooltipOffset },
  } = usePlayerSettings();

  const { t } = usePlayerTranslation();

  if (!nextMedia) {
    return <></>;
  }

  return (
    <ToggleButton
      variant="secondary"
      icon={<NextIcon aria-hidden="true" focusable="false" />}
      tooltip={t("PLAYER_TOOLTIP_NEXT_EPISODE")}
      tooltipOffset={tooltipOffset}
      onVisibilityChange={toggleSettings}
      iconOnly
    >
      <NextEpisodeDialog />
    </ToggleButton>
  );
};
